import { SET_APPOINTMENT_TYPES } from './appointment-types.actions';

const initialState = [];

export const appointmentTypesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_APPOINTMENT_TYPES:
      return [...payload];
    default:
      return state;
  }
};
